export const siteConfig = {
  name: '年轻的岳母',
  tagline: '家庭关系与代际情感解析',
  description: '围绕「年轻的岳母」这一独特家庭角色，深度探讨代际关系、婆媳相处、女婿与岳母之间的情感边界与沟通技巧，帮助您建立和谐、健康的家庭关系，化解潜在矛盾，共创温馨家庭氛围。',
  keywords: '年轻的岳母,年轻岳母相处之道,女婿岳母关系,家庭代际关系,岳母婆媳矛盾,家庭情感边界,和谐家庭沟通技巧',
  url: 'https://www.nianqingyumu.com',
  author: '林婉清',
  foundingYear: 2024,
  email: 'contact@nianqingyumu.com',
  brandStory: `
    <p>「年轻的岳母」诞生于一个简单而深刻的洞察：在现代中国家庭中，岳母这一角色正在发生前所未有的变化。越来越多的岳母在四十多岁甚至更年轻时就成了岳母，她们既是传统意义上的长辈，又是依然充满活力的现代女性。</p>
    <p>这种独特的身份定位，给家庭关系带来了全新的挑战和机遇。传统的「婆媳关系」话题已被广泛讨论，但「岳母与女婿」「年轻岳母的独特心理」这些领域却鲜有人深入探索。</p>
    <p>我们是一个由家庭心理学研究者、资深情感咨询师和内容创作者组成的团队。我们相信，每一个家庭都值得拥有和谐温暖的关系，而理解是建立这种关系的第一步。</p>
    <p>在这里，我们不贩卖焦虑，不制造对立，而是用专业的知识和温暖的态度，帮助每一个家庭找到属于自己的相处之道。无论你是正在为岳母关系烦恼的女婿，还是希望被更好理解的年轻岳母，抑或是夹在母亲和丈夫之间的妻子，这里都有一份属于你的答案。</p>
  `,
  coreValues: [
    { title: '专业深度', description: '每篇文章都由家庭心理学背景的专家撰写或审核，确保内容的科学性和实用性。' },
    { title: '温暖共情', description: '我们理解每个家庭都有独特的处境，用温暖的态度而非说教的口吻传递知识。' },
    { title: '实用导向', description: '不只讲道理，更提供可落地的具体方法和行动指南，让改变真正发生。' },
  ],
  teamMembers: [
    { name: '林婉清', role: '创始人与主笔', description: '家庭心理学研究者，国家二级心理咨询师，专注于代际关系和家庭系统理论。十年咨询经验，帮助超过500个家庭重建和谐关系。', avatar: '林' },
    { name: '陈思远', role: '资深编辑', description: '前媒体人，现专注于家庭关系领域的深度内容创作。擅长将复杂的心理学理论转化为通俗易懂的生活智慧。', avatar: '陈' },
  ],
  contactInfo: {
    email: 'contact@nianqingyumu.com',
    wechat: 'nianqingyumu_official',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
  },
};

export const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/xiangchu-zhidao' },
  { name: '关于我们', path: '/about' },
];